import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

import type StoreService from 'scaleflow/services/store';

class BusinessGoalsGoalMetricsRoute extends Route {
  @service declare store: StoreService;

  beforeModel() {
    return this.store.findAll('metric');
  }

  model() {
    return this.modelFor('business.goals.goal');
  }
}

export default instrumentRoutePerformance(BusinessGoalsGoalMetricsRoute);
